import { useMemo } from 'react';
import qs from 'qs';
import { useLocation } from 'hooks';

const useLocationSearchParams = () => {
    const location = useLocation();
    const { search } = location;

    const parsedSearch = useMemo(
        () =>
            qs.parse(search, {
                plainObjects: true,
                ignoreQueryPrefix: true,
            }),
        [search],
    );

    return [parsedSearch];
};

export default useLocationSearchParams;
